<template>
  <div
    v-if="component && showPaymentSuccessful"
    id="successful-response"
  >
    <b-modal
      v-model="modalVisible"
      hide-header
      no-close-on-esc
      size="lg"
      ok-only
      static
      @ok="modalClosed"
    >
      <component
        :is="component"
        :debug="debug"
      />
    </b-modal>
  </div>
</template>

<script>
import PaymentResponseMixins from '../../mixins/payment-response-mixins.js'
import SquarePaymentsMixin from '../../mixins/square-payments'

export default {
  name: 'square-success-response-modal',
  mixins: [
    PaymentResponseMixins,
    SquarePaymentsMixin
  ],
  props: {
    component: {
      type: Object,
      required: false,
      default: () => null
    },
    debug: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      modalVisible: false
    }
  },
  watch: {
    showPaymentSuccessful: {
      handler: function(newVal) {
        this.modalVisible = newVal
      },
      immediate: true
    }
  },
  methods: {
    modalClosed: function() {
      this.$emit('closed', true)
    }
  }
}
</script>

<style>

</style>
